<template>
<div>
    <Cbarra>
        <template slot="slotTitle">Departamento de Educación Contínua</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'educacioncontinua'}">Educación Contínua</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-01-tab" data-toggle="pill" href="#v-pills-01" role="tab"
                            aria-controls="v-pills-01" aria-selected="true">
                            Introducción
                        </a>
                        <div class="nav-link title-call">
                            Oferta completa <i class="fas fa-angle-down color8 ml-1"></i>
                        </div>
                        <a class="nav-link sub-menu" id="v-pills-03-tab" data-toggle="pill" href="#v-pills-03"
                            role="tab" aria-controls="v-pills-03" aria-selected="false">
                            Cursos
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-04-tab" data-toggle="pill" href="#v-pills-04"
                            role="tab" aria-controls="v-pills-04" aria-selected="false">
                            Talleres
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-05-tab" data-toggle="pill" href="#v-pills-05"
                            role="tab" aria-controls="v-pills-05" aria-selected="false">
                            Diplomados
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-06-tab" data-toggle="pill" href="#v-pills-06"
                            role="tab" aria-controls="v-pills-06" aria-selected="false">
                            Capacitación
                        </a>
                        <a class="nav-link" id="v-pills-07-tab" data-toggle="pill" href="#v-pills-07" role="tab"
                            aria-controls="v-pills-07" aria-selected="false">
                            Becas y Descuentos
                        </a>
                        <a class="nav-link" id="v-pills-08-tab" data-toggle="pill" href="#v-pills-08" role="tab"
                            aria-controls="v-pills-08" aria-selected="false">
                            Inscripciones y Pagos
                        </a>
                        <a class="nav-link" id="v-pills-09-tab" data-toggle="pill" href="#v-pills-09" role="tab"
                            aria-controls="v-pills-09" aria-selected="false">
                            Comité de Educación Contínua
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-01" role="tabpanel"
                            aria-labelledby="v-pills-01-tab">
                            <div  v-for="(lista,key) in objTab0.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-03" role="tabpanel" aria-labelledby="v-pills-03-tab ">
                        

                        <div class="row">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3" v-for="(curso,index) in ListaCursos" :key="index">
                                    <div class="card card-cursos" >
                                        <div class="card-body" @click="Ver(curso)">
                                            <a href="#cursos" data-toggle="modal">
                                                <img :src="RutaFoto+curso.Foto" alt="Cursos ENES" class="img-fluid">
                                                <h6 class="text-center color_Azul mt-2">{{curso.Titulo}}
                                                </h6>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="v-pills-04" role="tabpanel" aria-labelledby="v-pills-04-tab ">
                             <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        <div class="tab-pane fade" id="v-pills-05" role="tabpanel" aria-labelledby="v-pills-05-tab ">
                            <div  v-for="(lista,key) in objTab3.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        <div class="tab-pane fade" id="v-pills-06" role="tabpanel" aria-labelledby="v-pills-06-tab ">
                            <div  v-for="(lista,key) in objTab4.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        <div class="tab-pane fade" id="v-pills-07" role="tabpanel" aria-labelledby="v-pills-07-tab ">
                            <div  v-for="(lista,key) in objTab5.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        <div class="tab-pane fade" id="v-pills-08" role="tabpanel" aria-labelledby="v-pills-08-tab ">
                             <div  v-for="(lista,key) in objTab6.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                        <div class="tab-pane fade" id="v-pills-09" role="tabpanel" aria-labelledby="v-pills-09-tab">
                            <div  v-for="(lista,key) in objTab7.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="2"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <modal-component v-if="showModal" @cerrar="CerrarM" size='modal-xl'>
			<template slot="titulo" >
                 {{ObjeModal.Titulo}}
            </template>
			<template slot="contenido" >
                    <div class="row justify-content-center">
                        <div class="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6">
                            <figure>
                                <img :src="RutaFoto+ObjeModal.Foto" alt="" class="img-fluid">
                            </figure>
                        </div>
                    </div>

                    <ul class="list-curso">
                        <li>
                            <h6>Duración</h6>
                            <p class="text-intalic">{{ObjeModal.Duracion}}</p>
                        </li>
                        <li>
                            <h6>Fechas y horarios</h6>
                            <p class="text-intalic"><b>{{ObjeModal.Horario}}</b><br> {{ObjeModal.Fechas}}</p>
                        </li>
                        <li>
                            <h6>Sede</h6>
                            <p class="text-intalic">{{ObjeModal.Sede}}</p>
                        </li>
                        <li>
                            <h6>Dirigido a</h6>
                            <p class="text-intalic">
                               {{ObjeModal.Dirigido}}
                            </p>
                        </li>
                        <li>
                            <h6>Temario</h6>
                            <p class="text-intalic">{{ObjeModal.Temario}}</p>
                        </li>
                        <li>
                            <h6>Imparte</h6>
                            <p class="text-intalic">{{ObjeModal.Imparte}}
                            </p>
                        </li>
                        <li>
                            <h6>Reseña curricular.</h6>
                            <p class="text-intalic">{{ObjeModal.ReseniaCurricular}}</p>
                        </li>
                        <li>
                            <h6>Requisitos</h6>
                            <p class="text-intalic">
                                {{ObjeModal.Requisitos}}
                            </p>
                        </li>
                        <li>
                            <h6>Costos</h6>
                            <p class="text-intalic">
                                {{ObjeModal.Costos}}
                            </p>
                        </li>
                        <li>
                            <h6>Cupo mínimo</h6>
                            <p class="text-intalic">{{ObjeModal.Cupo}}</p>
                        </li>
                    </ul>
                    <div class="row">
                        <div class="col-12 text-center">
                            <a :href="ObjeModal.Url" target="_blank" class="button" tabindex="0">
                                Ir al registro&nbsp;
                                <span class="fas fa-hand-point-right"></span>
                            </a>
                        </div>
                    </div>
			</template>
		</modal-component>

    
      
  </div>
</template>

<script>

import ModalComponent from "@/components/ModalComponent";
export default {
    components:{
        ModalComponent
    },
    data() {
        return {
            ObjeModal:{
                Duracion:"",
                IdCurso:0,
                Titulo:"",
                Fechas:"",
                Horario:"",
                Sede:"",
                Dirigido:"",
                Temario:"",
                Imparte:"",
                ReseniaCurricular:"",
                Requisitos:"",
                Costos:"",
                Cupo:"",
                Url:"",
                Foto:"",
            },
            showModal:false,
            ListaCursos:[],
            RutaFoto:"",
            urlApi:"inicio/investigacion",
            ListaContenido:[],
            oferta:{},
            Segurity:{},
            ConfCatalogo:{
				title:'Investigacion',
				isModal: true,
				obj: {}
            },
            ConfFiltro:{
				placeHSearch:'Puesto',
				valueSearch:'',
				entrada:25,
				pag:1,
				totalItems:0,
				pageSize:0,
            },
            ConfAcciones:{
            },
            ConfigBtnModal2:{
                emitAdd: 'NuevoModal2',
                emitDel: 'EliminarDetalle'
            },
			ConfModal: {
				ShowPie: true,
                Size:'md',
            },
            oBoton1:{
                NameOk:'Crear',
                ShowPie:true,
            },
            oModal2:{
                Titulo: 'Detalles del Tema',
                Size:'lg',
            },
            oBoton2:{
                TipoModal:2,
                ShowPie:true,
            },

            objTema0:{
                editar:false,
                Apartado: 'INTROEDUCACIONC',
                Realiza: 'AddTema'
            },

            objTema1:{
                editar:false,
                Apartado: 'CURSOSEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab1:{
                editar:false,
                Apartado: 'CURSOSEDUCACIONC',
                ListaDet: [],
            },
            objTab0:{
                editar:false,
                Apartado: 'INTROEDUCACIONC',
                ListaDet: [],
            },


            objTema2:{
                editar:false,
                Apartado: 'TALLERESEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab2:{
                editar:false,
                Apartado: 'TALLERESEDUCACIONC',
                ListaDet: [],
            },


            objTema3:{
                editar:false,
                Apartado: 'DIPLOMADOSEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab3:{
                editar:false,
                Apartado: 'DIPLOMADOSEDUCACIONC',
                ListaDet: [],
            },

            objTema4:{
                editar:false,
                Apartado: 'CAPACITACIONEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab4:{
                editar:false,
                Apartado: 'CAPACITACIONEDUCACIONC',
                ListaDet: [],
            },


            objTema5:{
                editar:false,
                Apartado: 'BECASEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab5:{
                editar:false,
                Apartado: 'BECASEDUCACIONC',
                ListaDet: [],
            },

            objTema6:{
                editar:false,
                Apartado: 'INSCRIPCIONESEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab6:{
                editar:false,
                Apartado: 'INSCRIPCIONESEDUCACIONC',
                ListaDet: [],
            },

            objTema7:{
                editar:false,
                Apartado: 'COMITEEDUCACIONC',
                Realiza: 'AddTema'
            },
            objTab7:{
                editar:false,
                Apartado: 'COMITEEDUCACIONC',
                ListaDet: [],
            },            
            
            
            RutaFile: '',
            RutaFileD: '',
            listIconos: [],  
        }
    },methods: {
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'EDUCACIONC',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                this.Segurity				= res.data.segurity;
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD              = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                
                let newObj0 = [];
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];
                let newObj4 = [];
                let newObj5 = [];
                let newObj6 = [];
                let newObj7 = [];

                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'CURSOSEDUCACIONC'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'TALLERESEDUCACIONC'){
                        newObj2.push(value)
                    } 
                    else if(value.Apartado == 'DIPLOMADOSEDUCACIONC'){
                        newObj3.push(value)
                    }
                    else if(value.Apartado == 'INTROEDUCACIONC'){
                        newObj0.push(value)
                    }
                    else if(value.Apartado == 'CAPACITACIONEDUCACIONC'){
                        newObj4.push(value)
                    } 
                     else if(value.Apartado == 'BECASEDUCACIONC'){
                        newObj5.push(value)
                    }
                    else if(value.Apartado == 'INSCRIPCIONESEDUCACIONC'){
                        newObj6.push(value)
                    }
                    else if(value.Apartado == 'COMITEEDUCACIONC'){
                        newObj7.push(value)
                    }      
                                        
                });

                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }

                if(newObj3.length > 0){
                    this.objTab3.editar = true;
                    this.objTab3.ListaDet = newObj3;
                }
                if(newObj0.length > 0){
                    this.objTab0.editar = true;
                    this.objTab0.ListaDet = newObj0;
                }
                if(newObj4.length > 0){
                    this.objTab4.editar = true;
                    this.objTab4.ListaDet = newObj4;
                }
                if(newObj5.length > 0){
                    this.objTab5.editar = true;
                    this.objTab5.ListaDet = newObj5;
                }
                if(newObj6.length > 0){
                    this.objTab6.editar = true;
                    this.objTab6.ListaDet = newObj6;
                }
                if(newObj7.length > 0){
                    this.objTab7.editar = true;
                    this.objTab7.ListaDet = newObj7;
                }
            });

            this.cursos();
        },

        async cursos()
        {
            await this.$http.get(
                'cursos/list',
                {
                    params:{TxtBusqueda:'',Entrada:1000,pag:1,IdDepartamento:1}
                }
            ).then( (res) => {
                this.ListaCursos 			= res.data.cursos;
                this.RutaFoto 			= res.data.RutaFoto;
            });
              
        },

        Ver(item){
            this.ObjeModal = item;
            this.showModal = true;
        },
        CerrarM(){
            this.ObjeModal = {
                Duracion:"",
                IdCurso:0,
                Titulo:"",
                Fechas:"",
                Horario:"",
                Sede:"",
                Dirigido:"",
                Temario:"",
                Imparte:"",
                ReseniaCurricular:"",
                Requisitos:"",
                Costos:"",
                Cupo:"",
                Url:"",
                Foto:"",
            };
            this.showModal = false;
        },

        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },

    },mounted() {
        window.scrollTo(0, 0);
        this.Lista();
        
    },
}
</script>

<style>

</style>